import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Polygon, Polyline } from 'react-leaflet';
import L from 'leaflet';
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import 'leaflet/dist/leaflet.css';
import Axios from "axios";
import { hasJWTToken } from "../Account/RouteGuard";

export function RobotLocation({ ang, fid }) {
    const [progressPath, setProgressPath] = useState([]);

    // Default boundaries - State allows them to update when edited/dragged
    const [farmBoundary, setFarmBoundary] = useState([[18.699450, 73.919250], [18.699450, 73.919450], [18.699250, 73.919450], [18.699250, 73.919250]]);
    const [opBoundary, setOpBoundary] = useState([[18.699408, 73.919297], [18.699408, 73.919386], [18.699277, 73.919386], [18.699277, 73.919284]]);

    // 1. FILTER LOGIC: Kills the extra direction icons at 0,0
    const isValid = (lat, lon) => {
        return lat > 18.5 && lat < 18.8 && lon > 73.8 && lon < 74.1;
    };

    const fetchData = async () => {
        const plant_id = sessionStorage.getItem("user_plantid");
        try {
            const res = await Axios.get(`https://bhuhit.com/api/PlantRobotsOperation?pid=${plant_id}&rt=multiple`);
            // Only keep rows that are physically at the farm
            const cleanData = res.data.filter(r => isValid(r.source_lat, r.source_lon));
            setProgressPath(cleanData);
        } catch (e) { console.error("Data Fetch Error:", e); }
    };

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 3000);
        return () => clearInterval(interval);
    }, []);

    // Red Start Marker with Number
    const createNumberedIcon = (num) => L.divIcon({
        className: 'row-id-icon',
        html: `<div style="background:#FF3131; color:white; width:22px; height:22px; border-radius:50%; border:2px solid white; display:flex; align-items:center; justify-content:center; font-weight:bold; font-size:11px; box-shadow:0 0 5px black;">${num}</div>`,
        iconSize: [22, 22], iconAnchor: [11, 11]
    });

    // Green Robot Directional Arrow
    const createRobotIcon = (angle) => L.divIcon({
        className: 'robot-arrow-icon',
        html: `<div style="transform: rotate(${angle}deg); transition: transform 0.5s ease;">
                <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="M12 2L4.5 20.29L5.21 21L12 18L18.79 21L19.5 20.29L12 2Z" fill="#39FF14" stroke="black" stroke-width="1.5"/>
                </svg>
               </div>`,
        iconSize: [24, 24], iconAnchor: [12, 12]
    });

    return (
        <div style={{ height: '750px', width: '100%', position: 'relative' }}>
            {hasJWTToken() ? (
                <MapContainer center={[18.69939, 73.91934]} zoom={19} style={{ height: '100%', width: '100%' }}>
                    <TileLayer url="https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}" maxZoom={22} />

                    {/* 2. EDITABLE POLYGON: Farm Boundary */}
                    <Polygon
                        positions={farmBoundary}
                        pathOptions={{ color: '#2196F3', weight: 2, fillOpacity: 0.1 }}
                        eventHandlers={{
                            add: (e) => e.target.pm.enable({ draggable: true }),
                            'pm:update': (e) => setFarmBoundary(e.target.getLatLngs()[0].map(l => [l.lat, l.lng]))
                        }}
                    />

                    {/* 3. EDITABLE POLYGON: Operation Area */}
                    <Polygon
                        positions={opBoundary}
                        pathOptions={{ color: '#39FF14', weight: 2, fillOpacity: 0.1 }}
                        eventHandlers={{
                            add: (e) => e.target.pm.enable({ draggable: true }),
                            'pm:update': (e) => setOpBoundary(e.target.getLatLngs()[0].map(l => [l.lat, l.lng]))
                        }}
                    />

                    {progressPath.map((row, i) => {
                        const start = [row.source_lat, row.source_lon];
                        const end = [row.destination_lat, row.destination_lon];
                        const robot = [row.current_lat || row.source_lat, row.current_lon || row.source_lon];
                        const rowNum = row.robotID || (i + 1);

                        return (
                            <React.Fragment key={`row-${rowNum}`}>
                                {/* 4. DRAGGABLE ROW LINE */}
                                <Polyline
                                    positions={[start, end]}
                                    pathOptions={{ color: 'white', weight: 2, opacity: 0.8 }}
                                    eventHandlers={{ add: (e) => e.target.pm.enable({ draggable: true }) }}
                                />

                                <Marker position={start} icon={createNumberedIcon(rowNum)} interactive={false} />
                                <Marker position={robot} icon={createRobotIcon(ang || 0)} />
                            </React.Fragment>
                        );
                    })}
                </MapContainer>
            ) : (
                <div style={{ padding: '20px', color: 'black' }}>Session authentication required.</div>
            )}

            {/* Action Button */}
            <button
                onClick={() => alert("Ready to save updated Polygons and Row lines!")}
                style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 1000, padding: '10px 20px', backgroundColor: '#39FF14', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 2px 10px rgba(0,0,0,0.3)' }}
            >
                SAVE ALL EDITS
            </button>
        </div>
    );
}

export default RobotLocation;